const Mode = {
  Irs: 1,
  Crs: 2
};

export default Mode;
